import {Tabs, Box, Typography} from '@mui/material';
import ArchiveTitleContainer
    from "@/src/components/journal-site/archive/mui-custom/archive-title-container/archive-title-container";
import ArchiveTitleBox from "@/src/components/journal-site/archive/mui-custom/archive-title-box/archive-title-box";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import {faBooks} from "@fortawesome/pro-duotone-svg-icons";
import ArchiveTitleText from "@/src/components/journal-site/archive/mui-custom/archive-title-text/archive-title-text";
import CardTitleDivider from "@/src/mui-custom/card/card-title-divider/card-title-divider";
import ArchiveBox from "@/src/components/journal-site/archive/mui-custom/archive-box/archive-box";
import VolumeItem from "@/src/components/journal-site/archive/volumes/volume-item/volume-item";
import { useTheme } from '@mui/material/styles';
import VolumesProps from "@/src/_types/Archive/volume-props";

const Volumes = (props: VolumesProps) => {
    const theme = useTheme();

    return (
        <ArchiveBox sx={{
            borderRight: `1px solid ${theme.palette.custom?.dividerBorderArchiveColor}`,
            boxShadow: `2.5px 0 0 -2px ${theme.palette.custom?.dividerBoxShadowArchiveColor}`,
        }}>
            <ArchiveTitleContainer>
                <ArchiveTitleBox>
                    <FontAwesomeIcon icon={faBooks} className={'icon'}/>
                    <ArchiveTitleText variant={"h4"}>
                        volumes
                    </ArchiveTitleText>
                </ArchiveTitleBox>
                <CardTitleDivider/>
            </ArchiveTitleContainer>

            <Box sx={{
                marginTop: '1.5rem',
            }}>
                {props.volumes.length > 0 ? (
                        <Tabs
                            orientation="vertical"
                            value={props.value}
                            onChange={props.onChange}
                            aria-label="Volume Tabs"
                            sx={{
                                overflow: 'unset !important',
                                '& .MuiTabs-scroller': {
                                    overflow: 'unset !important',
                                },
                                '& .MuiTabs-indicator': {
                                    backgroundColor: 'unset !important',
                                    ':after' : {
                                        content: '""',
                                        position: 'absolute',
                                        width: '1rem',
                                        height: '1rem',
                                        right: 'calc(-2rem - 2px)',
                                        top: '1.25rem',
                                        backgroundColor: theme.palette.background.paper,
                                        borderTop: `1px solid ${theme.palette.custom?.dividerBorderArchiveColor}`,
                                        borderRight: `1px solid ${theme.palette.custom?.dividerBorderArchiveColor}`,
                                        boxShadow: `1px -1px 0 0px ${theme.palette.custom?.dividerBoxShadowArchiveColor}`,
                                        transform: 'rotate(45deg)'
                                    }
                                },
                            }}
                        >
                            {props.volumes.map((volume, index) => (
                                <VolumeItem
                                    key={volume.volume_id}
                                    volume={volume}
                                    isSelected={props.value === index}
                                    onClick={(event) => props.onChange(event, index)}
                                    id={`vertical-tab-${index}`}
                                    ariaControls={`vertical-tabpanel-${index}`}
                                />
                            ))}
                        </Tabs>
                    ) :
                    (
                        <Typography>
                            {'No volume-item has been found!'}
                        </Typography>
                    )
                }
            </Box>
        </ArchiveBox>
    );
};

export default Volumes;
